import { baseApi } from "api/BaseApi";

import {
  ContactCategory,
  ContactSubmissionPayload,
  ContactSubmissionResponse,
} from "./contactUs.types";

const BASE_URL = "v2/qa";

export const contactUsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listContactCategories: build.query<ContactCategory[], void>({
      query: () => `${BASE_URL}/categories/`,
      providesTags: ["CONTACT_CATEGORIES"],
    }),

    submitContactForm: build.mutation<
      ContactSubmissionResponse,
      ContactSubmissionPayload
    >({
      query: (body) => ({
        url: `${BASE_URL}/contact/`,
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useListContactCategoriesQuery, useSubmitContactFormMutation } =
  contactUsApi;
